module.exports = __webpack_public_path__ + "img/banner_gamardzhoba.778c445.JPG";